import * as React from 'react';
import { UpdatesFromServer } from '../types';
import AnnouncementUpdateCard from '../AnnouncementUpdateCard';
import CelebrationUpdateCard from '../CelebartionUpdateCard';
import NewJoinerUpdateCard from '../NewJoinerUpdateCard';
import EmptyStateContent from '../../CommonComponents/EmptyStateContent';

type Props = {
  updates: ReadonlyArray<UpdatesFromServer>;
};

const pinAnnouncementsFirst = (
  updates: ReadonlyArray<UpdatesFromServer>,
): UpdatesFromServer[] => {
  const pinned: UpdatesFromServer[] = [];
  const remaining: UpdatesFromServer[] = [];

  updates.forEach((update) => {
    if (update.__typename === 'Announcement' && update.flair__Pinned__c) {
      pinned.push(update);
      return;
    }
    remaining.push(update);
  });

  return [...pinned, ...remaining];
};

const Updates: React.FC<React.PropsWithChildren<Props>> = ({ updates }) => {
  if (updates.length === 0) {
    return <EmptyStateContent />;
  }

  const sortedUpdates = pinAnnouncementsFirst(updates);

  return (
    <>
      {sortedUpdates.map((u) => {
        switch (u.__typename) {
          case 'Announcement':
            return (
              <AnnouncementUpdateCard key={u.Id} announcementFragment={u} />
            );
          case 'Celebration':
            return <CelebrationUpdateCard key={u.Id} celebrationFragment={u} />;
          case 'Colleague':
            return <NewJoinerUpdateCard key={u.Id} newJoinerFragment={u} />;
        }

        return null;
      })}
    </>
  );
};

export default Updates;
